import { CommentTextarea } from '../CommentTextarea'
import type { TIcsDashboardData } from '../types'
import { CropWaterConsumption } from './CropWaterConsumption'
import { IrrigationPlannedNextWeek } from './IrrigationPlannedNextWeek'
import { IrrigationPlannerTable } from './IrrigationPlannerTable'

export const Irrigation = ({
  eventsResponse,
  thisWeekDates,
  nextWeekDates,
  dailyEtNextWeek,
  dailyEtLastWeek,
  refetch,
  resetKey,
}: {
  eventsResponse: TIcsDashboardData['eventsResponse']
  thisWeekDates: TIcsDashboardData['thisWeekDates']
  nextWeekDates: TIcsDashboardData['nextWeekDates']
  dailyEtNextWeek: TIcsDashboardData['dailyEtNextWeek']
  dailyEtLastWeek: TIcsDashboardData['dailyEtLastWeek']
  refetch: () => void
  resetKey: number
}) => {
  return (
    <div>
      <IrrigationPlannerTable
        eventsResponse={eventsResponse}
        thisWeekDates={thisWeekDates}
        nextWeekDates={nextWeekDates}
        dailyEtNextWeek={dailyEtNextWeek}
        dailyEtLastWeek={dailyEtLastWeek}
      />
      <CommentTextarea resetKey={resetKey} />
      <IrrigationPlannedNextWeek
        eventsResponse={eventsResponse}
        nextWeekDates={nextWeekDates}
        refetch={refetch}
      />
      <CommentTextarea resetKey={resetKey} />
      <CropWaterConsumption dailyEtNextWeek={dailyEtNextWeek} />
      <CommentTextarea resetKey={resetKey} />
    </div>
  )
}
